// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.CompanyInformation_hide__36SUI {\n  display: none !important; }\n", ""]);
// Exports
exports.locals = {
	"hide": "CompanyInformation_hide__36SUI"
};
module.exports = exports;
